import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  loadArchive: false,
  searchQuery: '',
  archive: [],
  total: 0,
  page: 1,
  totalPages: 0,
  hasMore: true,
  status: [],
  print: [],
  sewing: [],
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.archive = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.totalPages = action.payload.totalPages || 0;
      state.hasMore = action.payload.page < action.payload.totalPages;
    },
    appendArchiveData: (state, action) => {
      state.archive = [...state.archive, ...(action.payload.data || [])];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.totalPages = action.payload.totalPages || 0;
      state.hasMore = action.payload.page < action.payload.totalPages;
    },
    getAllAchiveStatus(state, action) {
      state.loadArchive = false;
      state.archive = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.totalPages = action.payload.totalPages || 0;
      state.hasMore = action.payload.page < action.payload.totalPages;
      state.loadArchive = true;
    },
    resetArchive: (state) => {
      state.archive = [];
      state.page = 1;
      state.total = 0;
      state.totalPages = 0;
      state.hasMore = true;
    },
    loadArchive(state, action) {
      state.loadArchive = action.payload;
    },
  }
});

// Мемоизированные селекторы
export const selectSearchState = state => state.search;

export const selectArchiveData = createSelector(
  [selectSearchState],
  (searchState) => ({
    status: searchState.status,
    archive: searchState.archive,
    loadArchive: searchState.loadArchive,
    total: searchState.total,
    page: searchState.page,
    totalPages: searchState.totalPages,
    hasMore: searchState.hasMore
  })
);

export const { setSearchQuery, appendArchiveData, getAllAchiveStatus, loadArchive, resetArchive } = searchSlice.actions;

export default searchSlice.reducer;
